<template>
  <div class="layout-segment">
    <div ref="resultsHeader" class="results-header">
      <div class="results-header__title">
        <div
          v-if="!groupTitle || ccountLoading"
          class="results-header__placeholder"
        >
          <div
            class="results-header__placeholder-title placeholder-animated"
          ></div>
          <div
            class="results-header__placeholder-counter placeholder-animated"
          ></div>
        </div>
        <template v-else>
          <h1 class="font-22 mb-6" v-show="showRegion">
            {{ groupTitle }}
            <template v-if="holidaysContext"> - wczasy i wycieczki </template>
          </h1>
          <span class="gray-50">Ilość ofert: {{ ccount }}</span>
        </template>
      </div>
    </div>
    <template v-if="isFirstPage">
      <div v-if="regionDescription" class="region-description">
        <p v-html="regionDescription[0]"></p>
        <template v-if="regionDescription.length > 1">
          <transition name="slide">
            <div v-show="isExpanded">
              <template v-for="(paragraph, idx) in regionDescription.slice(1)">
                <p :key="idx" v-html="paragraph"></p>
              </template>
            </div>
          </transition>
          <div class="collapser-line">
            <div
              @click="isExpanded = !isExpanded"
              class="collapser-line__button"
            >
              <span class="collapser-line__label">{{
                isExpanded ? "Zwiń opis" : "Rozwiń opis"
              }}</span>
              <span :class="{ _flip: isExpanded }" class="up-down-arrow"
                ><span></span><span></span
              ></span>
            </div>
          </div>
        </template>
      </div>
    </template>

      <template v-if="windowWidth < 768">
      <div
        class="btn btn-md btn-gray btn-block mb-32"
        @click="showSortOptionsModal"
      >
        <span class="btn__icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xml:space="preserve"
            fill="none"
            stroke="currentColor"
            stroke-width="1"
            viewBox="0 0 24 24"
          >
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="m3 9 4-4 4 4M7 5v14m14-4-4 4-4-4m4 4V5"
            />
          </svg>
        </span>
        Sortuj
      </div>
      <a-modal
        :confirmLoading="confirmLoadingSorting"
        :visible="visibleSortOptions"
        okText="Sortuj"
        cancelText="Anuluj"
        title="Sortuj oferty"
        wrapClassName="modal-mob"
        @ok="handleOkSorting"
        @cancel="handleCancelSorting"
      >
        <div class="mb-32">
          <div class="font-m mb-8">Sortuj oferty wg:</div>
          <a-radio-group :value="sortVal" @change="handleSortOption">
            <a-radio
              class="d-block text-capitalize mb-8"
              v-for="srt in sorts"
              :key="srt.kod"
              :value="srt.kod"
            >
              {{ srt.nazwa }}
            </a-radio>
          </a-radio-group>
        </div>

        <div class="font-m mb-8">Kolejność sortowania:</div>
        <a-radio-group :value="sortOrderVal" @change="handleSortOrder">
          <a-radio
            class="d-block text-capitalize mb-8"
            v-for="srt in sortOrders"
            :key="srt.kod"
            :value="srt.kod"
          >
            {{ srt.nazwa }}
          </a-radio>
        </a-radio-group>
      </a-modal>
    </template>

    <template v-else>
      <a-config-provider :locale="pl_PL">
        <div class="sort-tools mb-32">
          <div class="sort-tools__cell mr-32">
            <span class="d-inline-block font-m mr-8">Sortowanie wg:</span>
            <div class="sort-tools__form form-control-blue">
              <a-select
                :defaultValue="[]"
                class="w-100"
                v-model="valSort"
                @change="handleChangeSort"
              >
                <a-select-option
                  v-for="item in sorts"
                  :id="item.kod"
                  :key="item.kod"
                  :selected="valSort.includes(item.kod)"
                >
                  {{ item.nazwa }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="sort-tools__cell">
            <span class="d-inline-block font-m mr-8"
              >Kolejność sortowania:</span
            >
            <div class="sort-tools__form form-control-blue">
              <a-select
                :defaultValue="[]"
                class="w-100"
                v-model="valSortOrder"
                @change="handleChangeSortOrder"
              >
                <a-select-option
                  v-for="item in sortOrders"
                  :id="item.kod"
                  :key="item.kod"
                  :selected="valSortOrder.includes(item.kod)"
                >
                  {{ item.nazwa }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>
      </a-config-provider>
    </template>

    <template v-if="offersAvailable">
      <T1ResultsOffersPlaceholder v-if="offersLoading" />
      <a-row v-else :gutter="[32, 32]" type="flex">
        <a-col
          :xs="24"
          :sm="12"
          :lg="8"
          v-for="(oferta, idx) in oferty"
          :key="idx"
        >
          <T1ResultsOfferCard
            :schowek="getOfertySchowek()"
            :oferta="getOffersItems(idx)"
          />
        </a-col>
      </a-row>
      <T1Paginacja :ccount.sync="ccount" />
    </template>
    <template v-else>
      <T1NoOffers />
    </template>
    <T1RegionsTags
      v-if="getTGroupsBoxVisible() && groupBoxData.length > 0"
      :groupBoxData="groupBoxData"
      :groupBoxImage="groupBoxImage"
      :groupBoxTitle="groupBoxTitle"
    />
  </div>
</template>

<script>
import axios from "axios";
import T1ResultsOffersPlaceholder from "./T1Placeholders/T1ResultsOffersPlaceholder";
import T1NoOffers from "./T1Placeholders/T1NoOffers";
import T1ResultsOfferCard from "./T1OfferCards/T1ResultsOfferCard";
import T1Paginacja from "./T1Paginacja";
import T1VarLoader from "./T1VarLoader";
import * as CONFIG from "./config.js";
import T1RegionsTags from "./T1Assets/T1RegionsTags";
import { sorting } from "./sorts.js";
import { sortingOrders } from "./sortOrders.js";
import pl_PL from "ant-design-vue/lib/locale-provider/pl_PL";
import "moment/locale/pl";
import moment from "moment";
moment.locale("pl");

axios.defaults.withCredentials = false;

export default {
  data: () => ({
    pl_PL,
    url: "/szukajoferty.json",
    regionsUrl: "/vueregions.json",
    treeurl: "/getprzewodnikgeotree.json",
    regions: [],
    offersTypesUrl: "/getrodzajoferty.xml",
    offersTypes: [],
    cenyurl: "/getrodzajofertyceny.json",
    cenyOferta: {},
    disabled: ["lato2016", "lato2017", "lato2018", "lato2019", "lato2020"],
    groupBoxData: [],
    groupBoxTitle: "",
    groupBoxImage: "",
    groupTitle: "",
    holidaysContext: false,
    dparams: "",
    oferty: [],
    offersAvailable: true,
    ccountLoading: true,
    ccount: 0,
    addon: "",
    schowek_offers: [],
    isExpanded: false,
    regionurl: "/getlokalizacje.xml",
    offertype: "/getrodzajoferta.xml",
    locidFromUrl: "",
    regionData: [],
    regionDescription: "",
    regiony: [],
    wlocid: "",
    showRegion: false,
    isFirstPage: true,
    rprefix: "",
    tgroupsbox: true,
    allowedUrls: ["/rodzaj-oferty/lato-2021.xml"],
    offersLoading: true,
    valSort: [0],
    sorts: sorting.sorts,
    sortVal: 0,
    valSortOrder: ["rosnąco"],
    sortOrders: sortingOrders.sortOrders,
    sortOrderVal: "ASC",
    confirmLoadingSorting: false,
    visibleSortOptions: false,
    windowWidth: window.innerWidth,
  }),
  methods: {
    getSortParams() {
      let lparams = this.$route.query;

      if (lparams["sort"]) {
        let val = lparams["sort"];
        let nval = Number(val);
        let codes = [];
        this.sortVal = nval;
        this.valSort = [];

        for (let i = 0; i < this.sorts.length; i++) {
          codes.push(this.sorts[i].kod);
        }

        if (codes.includes(nval)) {
          this.valSort.push(nval);
        } else {
          this.valSort.push(0);
        }
      }

      if (lparams["order"]) {
        let val = lparams["order"];
        let codes = [];
        this.sortOrderVal = val;
        this.valSortOrder = [];

        for (let i = 0; i < this.sortOrders.length; i++) {
          codes.push(this.sortOrders[i].kod);
        }

        if (codes.includes(val)) {
          this.valSortOrder.push(val);
        } else {
          this.valSortOrder.push("ASC");
        }
      }
    },
    showSortOptionsModal() {
      this.visibleSortOptions = true;
    },
    handleOkSorting() {
      let currentPath = this.$route.fullPath;
      let sortParam = this.$route.query["sort"];
      let sortOrderParam = this.$route.query["order"];

      if (sortParam != this.sortVal || sortOrderParam != this.sortOrderVal) {
        this.$router.push({
          path: currentPath,
          query: { sort: this.sortVal, order: this.sortOrderVal },
        });
      }

      this.confirmLoadingSorting = true;

      setTimeout(() => {
        this.visibleSortOptions = false;
        this.confirmLoadingSorting = false;
      }, 500);
    },
    handleCancelSorting() {
      this.getSortParams();
      this.visibleSortOptions = false;
    },
    handleSortOption(e) {
      this.valSort = [];
      this.valSort.push(e.target.value);
      this.sortVal = e.target.value;
    },
    handleSortOrder(e) {
      this.valSortOrder = [];
      this.valSortOrder.push(e.target.value);
      this.sortOrderVal = e.target.value;
    },
    handleChangeSort(value) {
      let currentPath = this.$route.fullPath;
      this.valSort = [];
      this.valSort.push(value);
      this.sortVal = value;
      this.$router.push({ path: currentPath, query: { sort: this.sortVal } });
    },
    handleChangeSortOrder(value) {
      let currentPath = this.$route.fullPath;
      this.valSortOrder = [];
      this.valSortOrder.push(value);
      this.sortOrderVal = value;
      this.$router.push({
        path: currentPath,
        query: { order: this.sortOrderVal },
      });
    },
    getOffersItems(i) {
      return this.oferty[i];
    },
    getOffersLoading() {
      setTimeout(() => {
        this.offersLoading = false;
        this.$emit("offersLoading", this.offersLoading);
      }, 150);
    },
    getMainRegionName() {
      return CONFIG.panstwo_nazwapl;
    },
    showRegionName(bool) {
      this.showRegion = bool;
    },
    setHolidaysContext(bool) {
      this.holidaysContext = bool;
    },
    getTGroupsBoxVisible() {
      return this.tgroupsbox;
    },
    getGeoTree() {
      var pars = "locid=" + this.wlocid;
      return axios
        .get(CONFIG.API_URL + this.treeurl + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getRegionsLinks() {
      return axios
        .get(CONFIG.API_URL + this.regionsUrl, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getOfferTypesPrices() {
      return axios
        .get(CONFIG.API_URL + this.cenyurl, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getAllOffersTypeData() {
      var that = this;
      var rodzajUrl = CONFIG.API_URL + this.offersTypesUrl;
      var result = jQuery.ajax({
        url: rodzajUrl,
        dataType: "xml",
        crossDomain: true,
        method: "GET",
        success: function (data) {
          let xmlObj = jQuery(data);
          let arr = [];

          xmlObj.find("item").each(function () {
            let newObj = {};
            let subObj = {};
            newObj.child = subObj;

            subObj.prefix = jQuery(this).find("prefix").text();

            subObj.snazwa = jQuery(this).find("snazwa").text();

            newObj.url = jQuery(this).attr("url");

            if (that.cenyOferta[subObj.prefix]) {
              arr.push({
                url: newObj.url,
                title: subObj.snazwa,
                current: false,
              });
            }
          });
          that.groupBoxData = arr.slice(1);
        },
        error: function (e) {
          console.log(e);
          console.log("Ajax Error");
        },
      });
      return result;
    },
    replaceLinkWithRelative(link) {
      if (
        link != "" &&
        link.indexOf("www.") !== -1 &&
        link.indexOf(".pl/") !== -1
      ) {
        let index = link.indexOf(".pl/");
        if (index > 0) {
          return link.substring(index + 3);
        } else {
          return link;
        }
      } else {
        return link;
      }
    },
    getOfferTypeData(type) {
      let that = this;
      let urltomatch = this.$route.path;
      let rodzajUrl = CONFIG.API_URL + this.offertype + "?prefix=" + type;
      let result = jQuery.ajax({
        url: rodzajUrl,
        dataType: "xml",
        crossDomain: true,
        method: "GET",
        success: function (data) {
          let xmlObj = jQuery(data);
          let xmlDataArr = [];

          xmlObj.find("item").each(function () {
            let newObj = {};
            let showItem = jQuery(this).attr("show");
            let url = jQuery(this).attr("url");

            if (showItem == "1" && url === urltomatch) {
              let mtitle = jQuery(this).find("metatitle").text();
              if (mtitle && mtitle != "") {
                that.$root.$emit("update:mtitle", mtitle);
              }
              let mdesc = jQuery(this).find("metadescription").text();
              if (mdesc && mdesc != "") {
                that.$root.$emit("update:mdesc", mdesc);
              }
              let opisElems = jQuery(this).find("tekstzb");
              let opisArr = [];

              if (jQuery(this).find("tekstzb p").length) {
                opisElems.find("p").each(function () {
                  jQuery(this)
                    .find("link")
                    .each(function () {
                      let link = jQuery(this).attr("to");
                      let linkTxt = jQuery(this).text();
                      jQuery(this).replaceWith(
                        '<a href="' + link + '">' + linkTxt + "</a>"
                      );
                    });
                  opisArr.push(jQuery(this).html());
                });
                newObj.opis = opisArr;
              } else {
                opisArr.push(opisElems.html());
                newObj.opis = opisArr;
              }
              that.regionDescription = newObj.opis;

              newObj.snazwa = jQuery(this).find("snazwa").text();
              that.groupTitle = newObj.snazwa;
              that.groupBoxTitle = "Wycieczki i wczasy - rodzaje ofert";
              that.$root.$emit("update:groupTitle", that.groupTitle);

              newObj.zdjecie = jQuery(this).attr("zdjecie");
            }
            that.groupBoxImage = newObj.zdjecie;
            xmlDataArr.push(newObj);
          });
          that.regionData = xmlDataArr;
        },
        error: function (e) {
          console.log(e);
          console.log("Ajax Error");
        },
      });
      this.showRegionName(true);
      return result;
    },
    getRegionData(locid) {
      var that = this;
      var rodzajUrl = CONFIG.API_URL + this.regionurl + "?locid=" + locid;
      var result = jQuery.ajax({
        url: rodzajUrl,
        dataType: "xml",
        crossDomain: true,
        method: "GET",
        success: function (data) {
          var xmlObj = jQuery(data);
          var xmlDataArr = [];
          var extend = xmlObj.find("item[show='1']").length;

          xmlObj.find("item").each(function () {
            let newObj = {};
            let showItem = jQuery(this).attr("show");

            if (showItem == "1" || extend == 0) {
              let opisElems = jQuery(this).find("opis");
              let opisArr = [];
              if (jQuery(this).find("opis p").length) {
                opisElems.find("p").each(function () {
                  jQuery(this)
                    .find("link")
                    .each(function () {
                      let link = jQuery(this).attr("to");
                      let linkTxt = jQuery(this).text();
                      jQuery(this).replaceWith(
                        '<a href="' +
                          that.replaceLinkWithRelative(link) +
                          '">' +
                          linkTxt +
                          "</a>"
                      );
                    });
                  opisArr.push(jQuery(this).html());
                });
                if (extend != 0) {
                  newObj.opis = opisArr;
                }
              }
              that.regionDescription = newObj.opis;

              let mtitle = jQuery(this).find("mtitle").text();
              if (mtitle && mtitle != "") {
                that.$root.$emit("update:mtitle", mtitle);
              }
              let mdesc = jQuery(this).find("mdescription").text();
              if (mdesc && mdesc != "") {
                that.$root.$emit("update:mdesc", mdesc);
              }

              newObj.photo = jQuery(this).find("photo").text();
              that.groupBoxImage = newObj.photo;

              newObj.name = jQuery(this).attr("nazwa");
              that.groupTitle = newObj.name;
              that.$root.$emit("update:groupTitle", that.groupTitle);
              that.groupBoxTitle =
                that.getMainRegionName() + " - wczasy wg regionów";
              extend = 1;
            }
            xmlDataArr.push(newObj);
          });
          that.regionData = xmlDataArr;
        },
        error: function (e) {
          console.log(e);
          console.log("Ajax Error");
        },
      });
      this.showRegionName(true);
      return result;
    },
    getOferty(typ) {
      //alert("PARAMS:" + this.dparams);
      var pars = this.dparams;
      var rContext = this.$route.path;
      if (
        rContext.indexOf("/wyjazdy/") !== -1 ||
        rContext.indexOf("/wakacje/") !== -1 ||
        rContext.indexOf("/last-minute/") !== -1 ||
        rContext.indexOf("/rodzaj-oferty/") !== -1
      ) {
        var ind = rContext.indexOf(".xml");
        if (ind !== -1) {
          this.url = rContext.substring(0, ind);
          this.tgroupsbox = true;
        } else {
          this.url = "/szukajoferty.json";
          this.tgroupsbox = false;
          this.showRegionName(true);
          this.groupTitle = CONFIG.panstwo_nazwa;
        }
      } else {
        this.url = "/szukajoferty.json";
        this.tgroupsbox = false;
        this.showRegionName(true);
        this.groupTitle = CONFIG.panstwo_nazwa;
      }
      console.log("Requesting URL:" + CONFIG.API_URL + this.url + "?" + pars);
      return axios
        .get(CONFIG.API_URL + this.url + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          /*alert("DATA:" + response.data);
               alert("STATUS:" + response.status);
               alert("DATA ITEMS:" + JSON.stringify(response.data));*/
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getOfertySchowek() {
      return this.schowek_offers;
    },
    tomatrix(obj) {
      if (obj != undefined) {
        if (obj instanceof Array) {
          return obj;
        } else {
          let z = [];
          z.push(obj);
          return z;
        }
      } else {
        return [];
      }
    },
    getQueryParams() {
      let that = this;
      let lparams = this.$route.query;
      let qs = Object.keys(lparams)
        .map((key) => {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(lparams[key])
          );
        })
        .join("&");
      this.dparams = qs;
    },
    getRouteParams() {
      let rContext = this.$route.path;
      if (
        rContext.indexOf("/wyjazdy/") !== -1 ||
        rContext.indexOf("/wakacje/") !== -1 ||
        rContext.indexOf("/last-minute/") !== -1
      ) {
        if (this.wlocid != "") {
          this.getRegionData(this.wlocid);
        }
      } else if (rContext.indexOf("/rodzaj-oferty/") !== -1) {
        if (this.rprefix != "") {
          this.getOfferTypeData(this.rprefix);
        } else if (this.allowedUrls.includes(rContext)) {
          this.rprefix = "lato=2021";
          this.getOfferTypeData(this.rprefix);
        }
      }
    },
    contextWczasy() {
      let that = this;
      let rContext = this.$route.path;
      if (
        rContext.indexOf("/wyjazdy/") !== -1 ||
        rContext.indexOf("/wakacje/") !== -1 ||
        rContext.indexOf("/last-minute/") !== -1
      ) {
        this.getRegionsLinks().then((data) => {
          that.groupBoxData = [];
          this.regions = this.tomatrix(data.regiony.item);
          this.regions.forEach(function (value) {
            let url = value.url;
            let index = url.indexOf(".pl/");
            let formattedUrl = "/" + url.substring(index + 4);
            let title = value.nazwa;
            that.groupBoxData.push({
              url: formattedUrl,
              title: title,
              current: false,
            });
          });
        });
        this.setHolidaysContext(true);
      }
    },
    contextRodzajeOfert() {
      let that = this;
      let rContext = this.$route.path;
      if (rContext.indexOf("/rodzaj-oferty/") !== -1) {
        this.getOfferTypesPrices().then((data) => {
          this.ceny = data.page.GrupyDost;
          this.ceny.forEach(function (value) {
            var id = value.id;
            var name = value.name;
            var key = name + "=" + id;
            if (typeof value.cenamin === "string") {
              that.cenyOferta[key] = value;
            }
          });
          this.getAllOffersTypeData();
        });
      }
    },
    detectLocalStorage() {
      if (window.localStorage) {
        console.log("LocalStorage FOUND.");
        if (!localStorage.getItem("t1uid")) {
          console.log("LocalStorage with items NOT found");
          return false;
        } else {
          console.log("LocalStorage with items found");
          console.log("t1uid: " + localStorage.getItem("t1uid"));
          // localStorage has the lateest item
          if (localStorage.getItem("t1needsync")) {
            localStorage.removeItem("t1needsync");
            if (localStorage.getItem("t1offers")) {
              this.schowek_offers = localStorage.getItem("t1offers").split(",");
            }
          }
          //return true;
          return false;
        }
      } else {
        return false;
      }
    },
    loadSchowekOffers() {
      var that = this;
      T1VarLoader.loadSchowekOffers().then((data) => {
        var xmlObj = jQuery(data);
        xmlObj.find("offer").each(function (index, elem) {
          var ofr_id = jQuery(elem).find("kodId").text();
          that.schowek_offers.push(ofr_id);
          if (index == 0) {
            var t1uid = jQuery(elem).find("t1uid").text();
            // save in LocalStorage
            localStorage.setItem("t1uid", t1uid);
            console.log("t1uid: " + t1uid);
          }
        });
        localStorage.setItem("t1offers", that.schowek_offers);
      });
    },
    getCurrentPageNumber() {
      let pparam = this.$route.query;

      if (pparam["page"]) {
        let val = decodeURIComponent(pparam["page"]);

        if (val != "1") {
          this.isFirstPage = false;
        } else {
          this.isFirstPage = true;
        }
      }
    },
    getRegionsSubpages() {
      let param = this.$route.query;
      let loc = this.wlocid;

      if (param["locid"]) {
        loc = decodeURIComponent(param["locid"]);
      } else {
        loc = this.wlocid;
      }
      this.$root.$emit("update:regionLocid", loc);
    },
  },
  mounted() {
    let that = this;
    this.getQueryParams();
    this.getSortParams();

    if (!this.detectLocalStorage()) {
      this.loadSchowekOffers();
    }

    this.getOferty("oferty").then((data) => {
      //alert('OFERTY:' + JSON.stringify(data.page.response));
      if (
        data.page.redir != "" &&
        (this.$route.path.indexOf("/oferta/szukaj.xml") != -1 ||
          data.page.redir !== this.$route.path)
      ) {
        var rContext = data.page.redir;
        this.$router.push({ path: rContext + "?" + this.dparams });
        return;
      }
      this.ccount = Number(data.page.count);
      this.ccountLoading = false;
      this.wlocid = data.page.wlocid;
      this.oferty = data.page.response;
      if (
        this.oferty.length == 0
          ? (this.offersAvailable = false)
          : (this.offersAvailable = true)
      );
      if (data.page.rprefix && data.page.rprefix != "") {
        this.rprefix = data.page.rprefix;
      }
      if (data.page.addon && data.page.addon != "") {
        this.addon = data.page.addon;
        console.log("EMITTING addon: " + this.addon);
        this.$root.$emit("update:addon", this.addon);
      }
      if (this.holidaysContext) {
        this.getGeoTree().then((data) => {
          let geotree = data.geotree.Country;
          that.regiony = geotree.Region;
          that.getRegionsSubpages();
        });
      }
      this.getRouteParams();
    });

    this.contextWczasy();
    this.contextRodzajeOfert();
    this.getCurrentPageNumber();

    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  watch: {
    oferty: function () {
      this.getOffersLoading();
    },
    dparams: function () {
      this.offersLoading = true;
      this.$emit("offersLoading", this.offersLoading);
    },
    $route(to, from) {
      let that = this;
      this.getQueryParams();
      this.getSortParams();

      if (!this.detectLocalStorage()) {
        this.loadSchowekOffers();
      }

      this.getOferty("oferty").then((data) => {
        //alert('OFERTY:' + JSON.stringify(data.page.response));
        if (
          data.page.redir != "" &&
          (this.$route.path.indexOf("/oferta/szukaj.xml") != -1 ||
            data.page.redir !== this.$route.path)
        ) {
          var rContext = data.page.redir;
          this.$router.push({ path: rContext + "?" + this.dparams });
          return;
        }
        this.ccount = Number(data.page.count);
        this.ccountLoading = false;
        this.wlocid = data.page.wlocid;
        this.$emit("update:ccount", this.ccount);
        this.oferty = data.page.response;
        if (
          this.oferty.length == 0
            ? (this.offersAvailable = false)
            : (this.offersAvailable = true)
        );
        if (data.page.addon && data.page.addon != "") {
          this.addon = data.page.addon;
          console.log("EMITTING addon: " + this.addon);
          this.$root.$emit("update:addon", this.addon);
        }
        if (this.holidaysContext) {
          this.getGeoTree().then((data) => {
            let geotree = data.geotree.Country;
            that.regiony = geotree.Region;
            that.getRegionsSubpages();
          });
        }
        this.getRouteParams();
      });
      this.contextWczasy();
      this.getCurrentPageNumber();
    },
  },
  components: {
    T1ResultsOffersPlaceholder,
    T1NoOffers,
    T1ResultsOfferCard,
    T1Paginacja,
    T1RegionsTags,
  },
};
</script>

<style lang="scss" scoped>
.results-header {
  margin-bottom: 24px;

  &__placeholder {
    width: 100%;

    &-title,
    &-counter {
      border-radius: 2px;
    }
    &-title {
      height: 28px;
      width: 100%;
      max-width: 360px;
      margin-bottom: 10px;
    }
    &-counter {
      height: 18px;
      width: 100px;
      margin-bottom: 2px;
    }
  }
}

.sort-tools {
  display: flex;

  &__cell {
    display: flex;
    align-items: center;
  }

  &__form {
    width: 180px;
  }
}

.btn__icon {
  display: inline-block;
  margin-right: 2px;
  height: 22px;
  width: 22px;
  vertical-align: middle;
}

.region-description {
  margin-bottom: 26px;
}

.slide-enter-active {
  transition: ease-in 0.35s;
}

.slide-leave-active {
  transition: cubic-bezier(0, 1, 0.5, 1) 0.35s;
}

.slide-enter-to,
.slide-leave {
  max-height: 100vh;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  max-height: 0;
  overflow: hidden;
}
</style>
